import { Component, OnInit } from '@angular/core';
import { ModalDescargaDatosPublicoComponent } from 'src/app/shared/components/modal-descarga-datos/modal-descarga-datos-publico.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit() {}

  showModalDescarga() {
    const dialogRef = this.dialog.open(ModalDescargaDatosPublicoComponent, {
      width: '400px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Descargar
        console.log('Descargar');
      }
    });

    return dialogRef;
  }
}
